import { render } from "./BDropdown.vue?vue&type=template&id=431a5534"
import script from "./BDropdown.vue?vue&type=script&lang=js"
export * from "./BDropdown.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__